import React from 'react'
import NavWrapper from '../navs'
import { Outlet } from 'react-router-dom'
import { Footer } from '../footer'

const AppContainer = () => {
  return (
    <div>
      <NavWrapper />
      <Outlet />
      <Footer />
    </div>
  )
}

export default AppContainer